// extracted by mini-css-extract-plugin
export var text = "_bh-0";